/* eslint-disable */
import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import 'contents/assets/scss/page/accounting.scss';
//component
import Tab from '../../../component/Inc/Tab';
import Calendar from '../../../component/Inc/Calendar';
import Modal from '../../../component/Inc/Modal';
function AccountingIncentive() {
  const navigate = useNavigate();
  const [tabIdx, setTabIdx] = useState(0);
  const [modalAlert, setModalAlert] = useState(0);
  const tab01 = [
    {title: '정산 대기', value: 0},
    {title: '정산', value: 1},
    {title: '지급 완료', type: 'blue', value: 2}
  ];
  return (
    <main className="com_container">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu8_7 active">인센티브 정산 관리</h2>
        </section>
        <section className="com_pg_container p_incentive">
          <div className="box full">
            <div className="com_board_list__top">
              <div className="board_select">
                <select className="select">
                  <option value="이지수능 (본사)">이지수능 (본사)</option>
                </select>
                <Tab data={tab01} tab={tabIdx} setTab={setTabIdx} tabStyle="fit_cont" />
              </div>
              <section className="com_board_search end">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <hr className="com_divider" />
            <Calendar />
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <div className="board_select">
                <div className="check">
                  <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                  <label htmlFor="rdo01">전체</label>
                  <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                  <label htmlFor="rdo02">교사</label>
                  <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                  <label htmlFor="rdo03">홍보교사</label>
                </div>
              </div>
              <section className="com_board_search end">
                <div className="com_count_wrapper">
                  <div className="operators">
                    <div className="operators_label">
                      <span className="operators_count">총 정산 건수</span>
                      <span className="operators_value">98건</span>
                    </div>
                  </div>
                  <div className="turnover">
                    <div className="turnover_label">
                      <span className="turnover_count">총 정산 금액</span>
                      <span className="turnover_value">46,500,000</span>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="70" />
                <col width="auto" />
                <col width="200" />
                <col width="200" />
                <col width="200" />
                <col width="200" />
                <col width="200" />
                <col width="200" />
                <col width="90" />
              </colgroup>
              <thead>
                <tr>
                  <th>선택</th>
                  <th>구분</th>
                  <th>홍보자 명</th>
                  <th>입금한 학생 수</th>
                  <th>총 회차</th>
                  <th>총 임금 금액</th>
                  <th>최종 정산금액</th>
                  <th>정산 상태</th>
                  <th>보기</th>
                </tr>
              </thead>
              <tbody>
                <tr className="selected_gray">
                  <td>
                    <input type="checkbox" id="chk01" className="com_chk" />
                    <label htmlFor="chk01" />
                  </td>
                  <td>홍보교사</td>
                  <td>
                    <button className="btn_link">김홍보103</button>
                  </td>
                  <td>
                    <button className="btn_link">45</button>
                  </td>
                  <td>465</td>
                  <td className="td_point">1,000,000</td>
                  <td className="td_point">840,000</td>
                  <td>
                    <button className="btn_link txt">
                      정산 <br />
                      2023, 05, 12
                    </button>
                  </td>
                  <td className="td_point">
                    <button className="txt btn_link" onClick={() => navigate('/Accounting/Incentive/Detail03')}>
                      보기
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>
                    <input type="checkbox" id="chk01" className="com_chk" />
                    <label htmlFor="chk01" />
                  </td>
                  <td>담임</td>
                  <td>
                    <button className="btn_link">김홍보103</button>
                  </td>
                  <td>
                    <button className="btn_link">45</button>
                  </td>
                  <td>465</td>
                  <td className="td_point">1,000,000</td>
                  <td className="td_point">840,000</td>
                  <td className="td_red">
                    <span className="btn_link">정산대기</span>
                  </td>
                  <td className="td_point">
                    <button className="txt btn_link" onClick={() => navigate('/Accounting/Incentive/Detail')}>
                      보기
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>
                    <input type="checkbox" id="chk01" className="com_chk" />
                    <label htmlFor="chk01" />
                  </td>
                  <td>교사</td>
                  <td>
                    <button className="btn_link">김홍보103</button>
                  </td>
                  <td>
                    <button className="btn_link">45</button>
                  </td>
                  <td>465</td>
                  <td className="td_point">1,000,000</td>
                  <td className="td_point">840,000</td>
                  <td className="td_point">
                    <button className="btn_link txt">
                      지급완료 <br />
                      2023, 05, 12
                    </button>
                  </td>
                  <td className="td_point">
                    <button className="txt btn_link" onClick={() => navigate('/Accounting/Incentive/Detail')}>
                      보기
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="com_board_list__bottom">
              <button
                onClick={() => {
                  setModalAlert(true);
                }}
                className="com_btn black xs"
              >
                선택항목 정산
              </button>
              <div className="com_btn_wrap">
                <button className="com_btn black xs btn_down_orange">다운로드</button>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Modal open={modalAlert} close={() => setModalAlert(false)} type="type_alert">
        <div className="content_container">
          <div className="txt padding_bottom_no">선택항목을 정산 하시겠습니까?</div>
        </div>
        <div className="btn_container">
          <button className="com_btn lightGray xs">취소</button>
          <button className="com_btn orange xs">확인</button>
        </div>
      </Modal>
    </main>
  );
}

export default AccountingIncentive;
